import * as React from 'react';
import EditPropertyPane from './EditPropertyPane';
import CreatePropertyPane from './CreatePropertyPane';
import { TimeZone, getAvailableTimeZones } from '../../../../api/Property';

interface State {
    availableTimeZones?: TimeZone[];
    errorMessage?: string;
}

interface Props {
    propertyId?: number;
    createUser: (companyId: number) => void;
    updateTreeview: () => void;
    updatePropertyId: (newPropertyId: number) => void;
    onPropertyDelete: () => void;
    companyCreatedFrom?: number;
    isAdvanceTab?: boolean;
}

class PropertyPane extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};

        this.handleErrorMessageUpdate = this.handleErrorMessageUpdate.bind(this);
    }

    async componentDidMount() {
        let timeZonesResult = await getAvailableTimeZones();
        if (timeZonesResult.success && timeZonesResult.data) {
            this.setState({ availableTimeZones: timeZonesResult.data });
        } else if (timeZonesResult.error) {
            this.setState({ errorMessage: timeZonesResult.error });
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.propertyId !== this.props.propertyId) {
            this.setState({ errorMessage: '' });
        }
    }

    render() {
        return this.props.propertyId ? (
            <EditPropertyPane
                {...this.props}
                {...this.state}
                propertyId={this.props.propertyId}
                onErrorMessageUpdate={this.handleErrorMessageUpdate}
                isAdvanceTab={this.props.isAdvanceTab}
            />
        ) : (
            <CreatePropertyPane
                companyCreatedFrom={this.props.companyCreatedFrom || 0}
                onPropertyCreate={newPropertyId => {
                    this.props.updateTreeview();
                    this.props.updatePropertyId(newPropertyId);
                }}
                {...this.state}
                onErrorMessageUpdate={this.handleErrorMessageUpdate}
            />
        );
    }

    handleErrorMessageUpdate(errorMessage?: string) {
        this.setState({ errorMessage: errorMessage });
    }
}

export default PropertyPane;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/PropertyPane.tsx